import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  FiCheckCircle,
  FiXCircle,
  FiSave,
  FiVolume2,
  FiClock,
  FiAlertTriangle,
  FiPlay,
} from "react-icons/fi";
import getApiBaseUrl from "../utils/api";

// ==========================================
// DATA
// ==========================================
const IELTS_DATA_LISTENING = {
  title: "IELTS Listening Practice Test",
  sections: [
    {
      id: "s1",
      title: "Section 1: Revision Note",
      audioSrc: "/audio/test1.mp3",
      questionGroups: [
        {
          instruction:
            "Complete the notes below. Write ONE WORD AND/OR A NUMBER for each answer.",
          image: null,
          questions: [
            {
              id: "q1",
              text: "Problem with: the brochure sample. Company name: ______ Hotel Chains",
              type: "fill_blank",
              answer: "central",
            },
            {
              id: "q2",
              text: "Letters of the ______ should be bigger.",
              type: "fill_blank",
              answer: "address",
            },
            {
              id: "q3",
              text: "The information of the ______ should be removed.",
              type: "fill_blank",
              answer: "pool",
            },
            {
              id: "q4",
              text: "Change the description under the top photo to ______.",
              type: "fill_blank",
              answer: "reception",
            },
            {
              id: "q5",
              text: "Use the picture with the ______ of the hotel.",
              type: "fill_blank",
              answer: ["view", "views"],
            },
            {
              id: "q6",
              text: "The ______ should be in red print.",
              type: "fill_blank",
              answer: ["price", "prices"],
            },
            {
              id: "q7",
              text: "Translate into ______.",
              type: "fill_blank",
              answer: "spanish",
            },
            {
              id: "q8",
              text: "Deadline: by the end of ______.",
              type: "fill_blank",
              answer: "july",
            },
            {
              id: "q9",
              text: "Address: No. 9 Green Drive, ______ , NY21300.",
              type: "fill_blank",
              answer: ["Cliffton"],
            },
            {
              id: "q10",
              text: "Telephone number: ______.",
              type: "fill_blank",
              answer: "903036602",
            },
          ],
        },
      ],
    },

    {
      id: "s2",
      title: "Section 2: Park Tour Guide",
      audioSrc: "/audio/test1.mp3",
      questionGroups: [
        {
          instruction: "Choose the correct letter A, B or C.",
          image: null,
          questions: [
            {
              id: "q11",
              text: "The most famous view in this park is:",
              type: "mcq",
              options: [
                "A. the largest waterfall worldwide",
                "B. the longest river in the world",
                "C. the biggest sub-tropical rainforest",
              ],
              answer: "C",
            },
            {
              id: "q12",
              text: "According to the tour guide, what is best to do on top of the mountain?",
              type: "mcq",
              options: [
                "A. having a picnic",
                "B. taking photos",
                "C. strolling about",
              ],
              answer: "A",
            },
            {
              id: "q13",
              text: "What did the tour guide recommend for experienced walkers?",
              type: "mcq",
              options: [
                "A. the mountain trail",
                "B. the bush track",
                "C. the creek circuit",
              ],
              answer: "C",
            },
            {
              id: "q14",
              text: "What is mentioned about the transport in the park?",
              type: "mcq",
              options: [
                "A. bicycles can be hired",
                "B. trams are available",
                "C. it is included in the ticket",
              ],
              answer: "C",
            },
            {
              id: "q15",
              text: "Which activity is provided for adults all year round?",
              type: "mcq",
              options: [
                "A. abseiling",
                "B. bungee jumping",
                "C. paragliding",
              ],
              answer: "A",
            },
            {
              id: "q16",
              text: "What should visitors do before going to the restaurant?",
              type: "mcq",
              options: [
                "A. make bookings",
                "B. ask for availability",
                "C. collect meal ticket at reception",
              ],
              answer: "C",
            },
          ],
        },

        {
          instruction:
            "Label the map below. Write the correct letter, A–I, next to questions 17–20.",
          image: "/images/campsite_map.png",
          mapOptions: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
          questions: [
            { id: "q17", text: "Campsite", type: "map", answer: "E" },
            {
              id: "q18",
              text: "Business Centre",
              type: "map",
              answer: "A",
            },
            { id: "q19", text: "Museum", type: "map", answer: "G" },
            { id: "q20", text: "Cafe", type: "map", answer: "D" },
          ],
        },
      ],
    },

    {
      id: "s3",
      title: "Section 3: Nursing Program Discussion",
      audioSrc: "/audio/test1.mp3",
      questionGroups: [
        {
          instruction: "Choose the correct letter A, B or C.",
          image: null,
          questions: [
            {
              id: "q21",
              text: "How old are the students in the nursing program?",
              type: "mcq",
              options: [
                "A. teenagers",
                "B. in their twenties",
                "C. different age groups",
              ],
              answer: "C",
            },
            {
              id: "q22",
              text: "What do the speakers say about the group project?",
              type: "mcq",
              options: [
                "A. improves relationships",
                "B. develops problem solving",
                "C. creates supportive environment",
              ],
              answer: "A",
            },
            {
              id: "q23",
              text: "Which part of the program surprised Paul?",
              type: "mcq",
              options: [
                "A. number of essays",
                "B. amount of practical work",
                "C. internship opportunity",
              ],
              answer: "A",
            },
            {
              id: "q24",
              text: "What do they feel about learning law?",
              type: "mcq",
              options: [
                "A. essential training",
                "B. too theoretical",
                "C. takes too much time",
              ],
              answer: "A",
            },
          ],
        },

        {
          instruction:
            "What improvement do the speakers suggest for each of the following? Choose SIX answers from the box A–H.",
          image: "/images/options_box.png",
          mapOptions: ["A", "B", "C", "D", "E", "F", "G", "H"],
          questions: [
            { id: "q25", text: "Essays", type: "map", answer: "E" },
            { id: "q26", text: "Lectures", type: "map", answer: "G" },
            { id: "q27", text: "Research", type: "map", answer: "C" },
            { id: "q28", text: "Online forum", type: "map", answer: "A" },
            {
              id: "q29",
              text: "Placement tests",
              type: "map",
              answer: "B",
            },
            { id: "q30", text: "Freshmen", type: "map", answer: "H" },
          ],
        },
      ],
    },

    {
      id: "s4",
      title: "Section 4: Penguins in Africa",
      audioSrc: "/audio/test1.mp3",
      questionGroups: [
        {
          instruction: "Write ONE WORD ONLY for each answer.",
          image: null,
          questions: [
            {
              id: "q31",
              text: "The ______ of their body remains constant.",
              type: "fill_blank",
              answer: "temperature",
            },
            {
              id: "q32",
              text: "They restrict their ______ on land from dusk till dawn.",
              type: "fill_blank",
              answer: ["movement", "movements"],
            },
            {
              id: "q33",
              text: "They cannot fly because they have heavy ______.",
              type: "fill_blank",
              answer: ["bone", "bones"],
            },
            {
              id: "q34",
              text: "They build nests in underground ______.",
              type: "fill_blank",
              answer: ["hole", "holes"],
            },
            {
              id: "q35",
              text: "Their main food source is ______.",
              type: "fill_blank",
              answer: "roots",
            },
            {
              id: "q36",
              text: "Predators include seals, seagulls and ______.",
              type: "fill_blank",
              answer: ["shark", "sharks"],
            },
            {
              id: "q37",
              text: "Seagulls often eat the penguin ______.",
              type: "fill_blank",
              answer: ["chick", "chicks"],
            },
            {
              id: "q38",
              text: "Penguins replace old ______ during moulting.",
              type: "fill_blank",
              answer: ["feather", "feathers"],
            },
            {
              id: "q39",
              text: "They fight for nesting ______ and food.",
              type: "fill_blank",
              answer: "space",
            },
            {
              id: "q40",
              text: "This helps increase the ______ of their genes.",
              type: "fill_blank",
              answer: "diversity",
            },
          ],
        },
      ],
    },
  ],
};

// ==========================================
// COMPONENT
// ==========================================
export default function IeltsListening() {
  const navigate = useNavigate();

  const [answers, setAnswers] = useState({});
  const [showResult, setShowResult] = useState(false);
  const [score, setScore] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const [audioError, setAudioError] = useState("");
  const [timeLeft, setTimeLeft] = useState(30 * 60);
  const [showSubmitConfirm, setShowSubmitConfirm] = useState(false);
  const [saveStatus, setSaveStatus] = useState(null);
  const [announcement, setAnnouncement] = useState("");

  const audioRefs = useRef({});
  const answersRef = useRef({});
  const audioLastTimeRef = useRef({});
  const hasSubmittedRef = useRef(false);
  // Mirrors hasStarted/showResult into a ref so the onPause handler
  // (registered once on the <audio> element) always reads the current
  // test state instead of a stale closure value.
  const testActiveRef = useRef(false);
  // Set right before we deliberately pause the audio ourselves (test
  // submitted/ended). The onPause handler's "force resume" logic reads
  // testActiveRef, but that ref only updates via a useEffect AFTER this
  // render commits — so a same-tick pause() call would still see the
  // old (true) value and immediately resume playback. This flag lets
  // onPause recognize "we meant to stop it" regardless of ref timing.
  const audioForceStopRef = useRef(false);
  const API_URL = getApiBaseUrl();

  useEffect(() => {
    answersRef.current = answers;
  }, [answers]);

  useEffect(() => {
    testActiveRef.current = hasStarted && !showResult;
  }, [hasStarted, showResult]);

  // The onPause handler only stops the audio from being paused WHILE
  // the test is active — it never actually pauses anything itself.
  // Without this, submitting the test (showResult becomes true) leaves
  // the recording running invisibly underneath the results screen.
  // This explicitly stops playback the moment results are shown.
  useEffect(() => {
    if (showResult) {
      Object.values(audioRefs.current).forEach((el) => {
        if (el) el.pause();
      });
    }
  }, [showResult]);

  // ==========================================
  // TIMER
  // ==========================================
  useEffect(() => {
    let timer;

    if (hasStarted && !showResult) {
      timer = setInterval(() => {
        setTimeLeft((prev) => (prev <= 1 ? 0 : prev - 1));
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [hasStarted, showResult]);

  // Auto-submit is triggered from its own effect (not from inside the
  // setTimeLeft updater above) so it can never fire twice — updater
  // functions passed to setState can be invoked more than once by React
  // (e.g. under StrictMode), which would otherwise risk double-scoring
  // and a duplicate save request.
  useEffect(() => {
    if (hasStarted && !showResult && timeLeft === 0) {
      handleCalculateScore();
    }
  }, [timeLeft, hasStarted, showResult]);

  // Spoken/announced time checkpoints for screen readers
  useEffect(() => {
    if (timeLeft === 300) setAnnouncement("Five minutes remaining.");
    else if (timeLeft === 60) setAnnouncement("One minute remaining.");
  }, [timeLeft]);

  // NOTE: There used to be an "auto play next audio" effect here that
  // chained separate <audio> elements for each section (s1 -> s2 -> s3
  // -> s4) using onended. Since every section pointed at the exact same
  // audio file, that just replayed the same recording four times back
  // to back. The test now has a single audio player (Part 1's) that
  // plays once, straight through — matching how a real listening test
  // audio track works.

  // ==========================================
  // HELPERS
  // ==========================================
  const formatTime = (s) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m}:${String(sec).padStart(2, "0")}`;
  };

  const normalizeLoose = (t) =>
    (t || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^\w]/g, "");

  // Token-preserving normalization: strips punctuation from each word but
  // keeps word boundaries intact. This matters because normalizeLoose
  // collapses ALL whitespace before comparing, which means a test-taker
  // could type "c l i f f s i d e" and have it silently match "cliffside" —
  // defeating word-count limits entirely, since any extra word can be
  // "hidden" by mashing it against its neighbour. Word-type answers must
  // be compared word-by-word so the word count is real and can't be gamed.
  const normalizeStrict = (t) =>
    (t || "")
      .toString()
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean)
      .map((w) => w.replace(/[^\w]/g, ""))
      .join(" ");

  const countWords = (t) =>
    (t || "").toString().trim().split(/\s+/).filter(Boolean).length;

  // Numeric-style answers (phone numbers, postcodes, addresses) get
  // flexible spacing/punctuation on purpose — "866 4428" and "866-4428"
  // are the same answer, and that's a formatting convention, not a
  // word-count violation.
  const isNumericAnswer = (s) => {
    const str = (s || "").toString().trim();
    return /\d/.test(str) && /^[\d\s\-()+.]+$/.test(str);
  };

  const normalize = normalizeLoose;

  // Single source of truth for fill-blank grading. Returns "correct",
  // "over_limit" (right content, too many words — a real IELTS miss but
  // worth explaining differently), or "incorrect".
  const getFillBlankFeedback = (userRaw, correctField, maxWords) => {
    const correctList = Array.isArray(correctField)
      ? correctField
      : [correctField];
    const userWordCount = countWords(userRaw);

    for (const c of correctList) {
      const numeric = isNumericAnswer(c);

      const matches = numeric
        ? normalizeLoose(userRaw) === normalizeLoose(c)
        : normalizeStrict(userRaw) === normalizeStrict(c);

      if (!matches) continue;

      if (!maxWords || numeric) return "correct";

      const alternativeWordCount = countWords(c);
      if (userWordCount <= Math.max(maxWords, alternativeWordCount)) {
        return "correct";
      }

      return "over_limit";
    }

    return "incorrect";
  };

  const checkAnswerMatch = (userRaw, correctField, maxWords) =>
    getFillBlankFeedback(userRaw, correctField, maxWords) === "correct";

  const displayAnswer = (correctField) =>
    Array.isArray(correctField) ? correctField[0] : correctField;

  const WORD_NUM = { ONE: 1, TWO: 2, THREE: 3, FOUR: 4, FIVE: 5 };

  const getMaxWords = (instruction) => {
    if (!instruction) return null;

    // "AND/OR A NUMBER" means the answer may be the word, the number, or
    // both together (e.g. a real answer key expecting "5 July" — a word
    // plus a number, two tokens). Treating this as a hard one-word limit
    // would wrongly reject a genuinely correct two-token answer.
    const allowsExtraNumber = /AND\s*\/?\s*OR\s*A\s*NUMBER/i.test(
      instruction
    );

    let base = null;

    const noMoreThan = instruction.match(
      /NO MORE THAN (ONE|TWO|THREE|FOUR|FIVE) WORDS?/i
    );
    if (noMoreThan) {
      base = WORD_NUM[noMoreThan[1].toUpperCase()];
    } else {
      const wordLimit = instruction.match(
        /\b(ONE|TWO|THREE|FOUR|FIVE) WORDS?\b/i
      );
      if (wordLimit) base = WORD_NUM[wordLimit[1].toUpperCase()];
    }

    if (base === null) return null;

    return allowsExtraNumber ? base + 1 : base;
  };

  const getTotalQuestions = () =>
    IELTS_DATA_LISTENING.sections.reduce(
      (acc, sec) =>
        acc +
        sec.questionGroups.reduce(
          (a2, grp) => a2 + grp.questions.length,
          0
        ),
      0
    );

  const getAnsweredCount = () =>
    Object.values(answers).filter(
      (v) => v && v.toString().trim() !== ""
    ).length;

  // Standard IELTS Listening raw-score-to-band conversion table.
  // This is the widely published approximate scale used across
  // official practice materials; actual test conversions can shift
  // very slightly test-to-test, but this table is the standard
  // reference used for self-marking practice tests.
  const LISTENING_BAND_TABLE = [
    { min: 39, max: 40, band: 9 },
    { min: 37, max: 38, band: 8.5 },
    { min: 35, max: 36, band: 8 },
    { min: 32, max: 34, band: 7.5 },
    { min: 30, max: 31, band: 7 },
    { min: 26, max: 29, band: 6.5 },
    { min: 23, max: 25, band: 6 },
    { min: 18, max: 22, band: 5.5 },
    { min: 16, max: 17, band: 5 },
    { min: 13, max: 15, band: 4.5 },
    { min: 10, max: 12, band: 4 },
    { min: 8, max: 9, band: 3.5 },
    { min: 6, max: 7, band: 3 },
    { min: 4, max: 5, band: 2.5 },
    { min: 0, max: 3, band: 2 },
  ];

  const getBandScore = (rawScore) => {
    const row = LISTENING_BAND_TABLE.find(
      (r) => rawScore >= r.min && rawScore <= r.max
    );
    return row ? row.band : 0;
  };

  const formatBand = (band) =>
    Number.isInteger(band) ? band.toFixed(1) : band.toString();

  // ==========================================
  // START TEST
  // ==========================================
  const startTest = () => {
    setAudioError("");

    const firstAudio = audioRefs.current["s1"];

    if (firstAudio) {
      firstAudio.currentTime = 0;

      firstAudio
        .play()
        .then(() => {
          setHasStarted(true);
        })
        .catch(() => {
          setAudioError(
            "Audio file not found. Please check /public/audio/test1.mp3"
          );
        });
    } else {
      setAudioError(
        "Could not initialize the audio player. Please refresh and try again."
      );
    }
  };

  // ==========================================
  // ANSWERS
  // ==========================================
  const handleInput = (qId, value) => {
    setAnswers((prev) => ({
      ...prev,
      [qId]: value,
    }));
  };

  // ==========================================
  // SCORE
  // ==========================================
  const handleCalculateScore = () => {
    if (hasSubmittedRef.current) return;
    hasSubmittedRef.current = true;

    let s = 0;
    let total = 0;

    const breakdown = {};
    const currentAnswers = answersRef.current;

    IELTS_DATA_LISTENING.sections.forEach((sec) => {
      sec.questionGroups.forEach((grp) => {
        const maxWords = getMaxWords(grp.instruction);

        grp.questions.forEach((item) => {
          total++;

          const userVal = currentAnswers[item.id];

          const isCorrect =
            item.type === "mcq" || item.type === "map"
              ? normalize(userVal).charAt(0) ===
                normalize(item.answer).charAt(0)
              : checkAnswerMatch(userVal, item.answer, maxWords);

          if (isCorrect) s++;

          breakdown[item.id] = {
            user: userVal || "",
            correct: displayAnswer(item.answer),
            isCorrect,
          };
        });
      });
    });

    setScore(s);
    setShowResult(true);

    // Test is over — stop the audio immediately instead of letting it
    // keep playing in the background underneath the results banner.
    const audioEl = audioRefs.current["s1"];
    if (audioEl && !audioEl.paused) {
      audioForceStopRef.current = true;
      audioEl.pause();
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    saveResult(s, total, breakdown);
  };

  const handleSubmitClick = () => {
    const total = getTotalQuestions();
    const answered = getAnsweredCount();

    if (answered < total) {
      setShowSubmitConfirm(true);
    } else {
      handleCalculateScore();
    }
  };

  // ==========================================
  // SAVE RESULT
  // ==========================================
  const saveResult = async (finalScore, total, breakdown) => {
    const token = localStorage.getItem("token");

    if (!token) {
      setSaveStatus("skipped");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/tests/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          testName: IELTS_DATA_LISTENING.title,
          result: {
            score: finalScore,
            total,
            percentage: Math.round((finalScore / total) * 100) + "%",
            band: getBandScore(finalScore),
            breakdown,
          },
        }),
      });

      setSaveStatus(res.ok ? "saved" : "failed");
    } catch (err) {
      console.error(err);
      setSaveStatus("failed");
    }
  };

  // ==========================================
  // QUESTION
  // ==========================================
  const renderQuestion = (item, maxWords) => {
    const userAns = normalize(answers[item.id]);
    const correctAns = normalize(displayAnswer(item.answer));

    let isCorrect = false;
    let fillBlankReason = null;

    if (showResult) {
      if (item.type === "mcq" || item.type === "map") {
        isCorrect = userAns.charAt(0) === correctAns.charAt(0);
      } else {
        fillBlankReason = getFillBlankFeedback(
          answers[item.id],
          item.answer,
          maxWords
        );
        isCorrect = fillBlankReason === "correct";
      }
    }

    const wordCount = (answers[item.id] || "")
      .trim()
      .split(/\s+/)
      .filter(Boolean).length;

    const overWordLimit =
      !showResult && maxWords && wordCount > maxWords;

    return (
      <div className="il-question" key={item.id}>
        <div className="il-q-row">
          <div
            className={`il-q-num ${
              showResult ? (isCorrect ? "correct" : "wrong") : ""
            }`}
          >
            {item.id.replace("q", "")}
          </div>

          <div className="il-q-body">
            {/* FILL BLANK */}
            {item.type === "fill_blank" && (
              <div className="il-q-text">
                {item.text.split("______").map((part, i, arr) => (
                  <span key={i}>
                    {part}

                    {i < arr.length - 1 &&
                      (showResult ? (
                        <span
                          className={`il-blank-result ${
                            isCorrect ? "il-blank-correct" : "il-blank-wrong"
                          }`}
                        >
                          {answers[item.id] || "—"}
                        </span>
                      ) : (
                        <input
                          className={`il-input ${
                            overWordLimit ? "il-input-warning" : ""
                          }`}
                          type="text"
                          value={answers[item.id] || ""}
                          onChange={(e) =>
                            handleInput(item.id, e.target.value)
                          }
                        />
                      ))}
                  </span>
                ))}

                {overWordLimit && (
                  <div className="il-word-warning">
                    Max {maxWords} word{maxWords > 1 ? "s" : ""}{" "}
                    allowed — you typed {wordCount}.
                  </div>
                )}
              </div>
            )}

            {/* MCQ */}
            {item.type === "mcq" && (
              <>
                <div className="il-q-text">{item.text}</div>

                <div className="il-options">
                  {item.options.map((opt) => {
                    const letter = opt.charAt(0);

                    const isSelected = answers[item.id] === letter;

                    const isCorrectOpt =
                      showResult &&
                      letter === correctAns.charAt(0).toUpperCase();

                    const isWrongSel =
                      showResult && isSelected && !isCorrectOpt;

                    return (
                      <div
                        key={opt}
                        className={`il-option ${
                          !showResult && isSelected ? "selected" : ""
                        } ${
                          showResult && isCorrectOpt
                            ? "result-correct"
                            : ""
                        } ${
                          showResult && isWrongSel ? "result-wrong" : ""
                        }`}
                        onClick={() => {
                          if (!showResult)
                            handleInput(item.id, letter);
                        }}
                      >
                        <div
                          className={`il-radio ${
                            !showResult && isSelected
                              ? "checked"
                              : ""
                          } ${
                            showResult && isCorrectOpt
                              ? "correct-radio"
                              : ""
                          } ${
                            showResult && isWrongSel
                              ? "wrong-sel"
                              : ""
                          }`}
                        />

                        <span className="il-option-text">{opt}</span>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {/* REVEAL */}
            {showResult && !isCorrect && (
              <div className="il-answer-reveal">
                {item.type === "mcq" || item.type === "map" ? (
                  <div>
                    Your answer:{" "}
                    <strong>
                      {answers[item.id] || "No answer given"}
                    </strong>
                  </div>
                ) : null}

                {fillBlankReason === "over_limit" ? (
                  <div>
                    Your answer had the right idea but used too many
                    words (limit: {maxWords}). Correct answer:{" "}
                    <strong>{displayAnswer(item.answer)}</strong>
                  </div>
                ) : (
                  <div>
                    Correct answer:{" "}
                    <strong>{displayAnswer(item.answer)}</strong>
                  </div>
                )}

                {item.explanation && (
                  <div>Explanation: {item.explanation}</div>
                )}
              </div>
            )}
          </div>

          {/* RESULT ICON */}
          {showResult && (
            <div className="il-result-icon">
              {isCorrect ? (
                <FiCheckCircle size={20} color="#19a96b" />
              ) : (
                <FiXCircle size={20} color="#e55" />
              )}
            </div>
          )}
        </div>
      </div>
    );
  };
  // ==========================================
  // MAP GROUP
  // ==========================================
  const renderMapGroup = (grp) => {
    return (
      <div className="il-map-layout">
        {/* IMAGE */}
        {grp.image ? (
          <div className="il-map-img-wrap">
            <img
              src={grp.image}
              alt="map"
              className="il-map-img"
            />
          </div>
        ) : (
          <div className="il-map-placeholder">No image</div>
        )}

        {/* TABLE */}
        <div className="il-map-table-wrap">
          <table className="il-map-table">
            <thead>
              <tr>
                <th className="il-map-th-label"></th>

                {grp.mapOptions.map((letter) => (
                  <th key={letter} className="il-map-th">
                    {letter}
                  </th>
                ))}

                <th className="il-map-th-icon"></th>
              </tr>
            </thead>

            <tbody>
              {grp.questions.map((item) => {
                const userAns = normalize(answers[item.id]);

                const correctAns = normalize(item.answer);

                const isCorrect =
                  userAns.charAt(0) === correctAns.charAt(0);

                return (
                  <React.Fragment key={item.id}>
                    <tr>
                      <td className="il-map-td-label">
                        <div className="il-map-td-label-inner">
                          <span className="il-q-num sm">
                            {item.id.replace("q", "")}
                          </span>

                          <span className="il-map-text">
                            {item.text}
                          </span>
                        </div>
                      </td>

                      {grp.mapOptions.map((letter) => {
                        const isSelected =
                          answers[item.id] === letter;

                        const isCorrectOpt =
                          showResult &&
                          letter ===
                            correctAns.charAt(0).toUpperCase();

                        const isWrongSel =
                          showResult &&
                          isSelected &&
                          !isCorrectOpt;

                        return (
                          <td
                            key={letter}
                            className="il-map-td-radio"
                            onClick={() => {
                              if (!showResult)
                                handleInput(item.id, letter);
                            }}
                          >
                            <div
                              className={`il-radio-cell ${
                                !showResult && isSelected
                                  ? "radio-checked"
                                  : ""
                              } ${
                                showResult && isCorrectOpt
                                  ? "radio-correct"
                                  : ""
                              } ${
                                showResult && isWrongSel
                                  ? "radio-wrong"
                                  : ""
                              }`}
                            />
                          </td>
                        );
                      })}

                      <td className="il-map-td-icon">
                        {showResult &&
                          (isCorrect ? (
                            <FiCheckCircle
                              size={16}
                              color="#19a96b"
                            />
                          ) : (
                            <FiXCircle
                              size={16}
                              color="#e55"
                            />
                          ))}
                      </td>
                    </tr>

                    {showResult && !isCorrect && (
                      <tr className="il-map-tr-reveal">
                        <td
                          colSpan={grp.mapOptions.length + 2}
                          className="il-map-td-reveal"
                        >
                          <div className="il-answer-reveal">
                            <div>
                              Your answer:{" "}
                              <strong>
                                {answers[item.id] || "No answer given"}
                              </strong>
                            </div>
                            <div>
                              Correct answer:{" "}
                              <strong>{item.answer}</strong>
                            </div>
                            {item.explanation && (
                              <div>Explanation: {item.explanation}</div>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // ==========================================
  // UI
  // ==========================================
  return (
    <>
      <div className="il-page">
        {/*
          NOTE: the <style> tag now lives here, at the top level of the
          page, instead of being nested inside the timer bar. Previously
          it was buried inside `.il-timer-bar` — which meant hiding the
          timer bar (e.g. on the results screen) would have deleted all
          the page's CSS along with it. Now styling is always present
          regardless of what's conditionally rendered below.
        */}
        <style>{`
  *{
    box-sizing:border-box;
  }

  html,
  body,
  #root{
    width:100%;
    overflow-x:hidden;
    margin:0;
    padding:0;
  }

  body{
    background:#f4f7f4;
    font-family:Arial, Helvetica, sans-serif;
    color:#1f2937;
  }

  .il-page{
    width:100%;
    min-height:100vh;
    background:#f4f7f4;
    overflow-x:hidden;
  }

  .il-container{
    width:100%;
    max-width:1200px;
    margin:auto;
    padding:20px 24px 40px;
  }

  .il-container-no-timer{
    padding-top:100px;
  }

.il-timer-bar{
  position: sticky;
  top: 80px;
  z-index: 999;
  width: 100%;
  background: white;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 2px 10px rgba(0,0,0,.05);
  padding: 14px 24px;

  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
}

.il-timer-left{
  grid-column: 2;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.il-timer-bar h1{
  margin: 0;
  font-size: clamp(16px,2.4vw,22px);
  color: #047857;
  font-weight: 800;
  line-height: 1.2;
}

.il-timer-subtitle{
  font-size: 12.5px;
  color: #6b7280;
  font-weight: 600;
}

.il-timer-right{
  grid-column: 3;
  justify-self: end;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.il-timer-clock{
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  color: #059669;
  background: #ecfdf5;
  border: 1px solid #bbf7d0;
  padding: 10px 18px;
  border-radius: 999px;
}

.il-progress-pill{
  font-size: 13px;
  font-weight: 700;
  color: #047857;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  padding: 9px 16px;
  border-radius: 999px;
  white-space: nowrap;
}

.warning{
  color: #dc2626;
}

  .il-live-badge{
    background:#ecfdf5;
    border:1px solid #bbf7d0;
    color:#047857;
    padding:9px 16px;
    border-radius:999px;
    display:inline-flex;
    align-items:center;
    gap:8px;
    margin-bottom:16px;
    font-size:13px;
    font-weight:700;
  }

  .il-live-dot{
    width:8px;
    height:8px;
    background:#22c55e;
    border-radius:50%;
    animation:blink 1s infinite;
  }

  @keyframes blink{
    0%{opacity:1}
    50%{opacity:.3}
    100%{opacity:1}
  }

  .il-section{
    background:white;
    border-radius:18px;
    overflow:hidden;
    margin-bottom:20px;
    border:1px solid #e5e7eb;
    box-shadow:0 6px 24px rgba(0,0,0,.04);
  }

  .il-section-header{
    background:linear-gradient(
      135deg,
      #047857,
      #10b981
    );
    color:white;
    padding:14px 22px;
  }

  .il-section-label{
    font-size:11px;
    color:#d1fae5;
    margin-bottom:5px;
    text-transform:uppercase;
    letter-spacing:1px;
  }

  .il-section-title{
    font-size:clamp(18px,3vw,24px);
    font-weight:700;
  }

  .il-audio-wrap{
    display:flex;
    gap:14px;
    align-items:center;
    padding:12px 22px;
    background:#f9fafb;
    border-bottom:1px solid #e5e7eb;
    flex-wrap:wrap;
  }

  .il-audio-wrap span{
    font-weight:700;
    color:#065f46;
  }

  .il-audio-wrap audio{
    flex:1;
    width:100%;
    min-width:220px;
  }

  .il-audio-wrap audio::-webkit-media-controls-timeline{
    pointer-events:none !important;
    opacity:0.5 !important;
  }

  .il-audio-wrap audio::-webkit-media-controls-timeline-container{
    pointer-events:none !important;
  }

  .il-audio-wrap.il-audio-disabled{
    opacity:0.5;
    pointer-events:none;
    filter:grayscale(40%);
  }

  .il-audio-note{
    width:100%;
    font-size:12px;
    font-weight:400;
    color:#9ca3af;
  }

  .il-save-note{
    margin-top:14px;
    font-size:13px;
    font-weight:600;
    padding:10px 14px;
    border-radius:10px;
  }

  .il-save-note.saved{
    background:#ecfdf5;
    color:#047857;
  }

  .il-save-note.failed{
    background:#fef2f2;
    color:#dc2626;
  }

  .il-save-note.skipped{
    background:#f9fafb;
    color:#6b7280;
  }

  .il-sr-only{
    position:absolute;
    width:1px;
    height:1px;
    padding:0;
    margin:-1px;
    overflow:hidden;
    clip:rect(0,0,0,0);
    white-space:nowrap;
    border:0;
  }

  .il-group{
    padding:18px 22px 6px;
  }

  .il-instruction{
    background:#f0fdf4;
    border-left:4px solid #10b981;
    padding:12px 16px;
    margin-bottom:16px;
    border-radius:10px;
    line-height:1.6;
    font-size:14.5px;
    color:#065f46;
  }

  .il-questions-grid{
    display:grid;
    grid-template-columns:repeat(auto-fit, minmax(340px, 1fr));
    column-gap:32px;
  }

  .il-question{
    padding:14px 0;
    border-bottom:1px solid #f0f0f0;
  }

  .il-q-row{
    display:flex;
    gap:14px;
    align-items:flex-start;
  }

  .il-q-num{
    width:36px;
    height:36px;
    border-radius:50%;
    background:#047857;
    color:white;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:13px;
    font-weight:700;
    flex-shrink:0;
  }

  .il-q-num.sm{
    width:28px;
    height:28px;
    font-size:11px;
  }

  .correct{
    background:#10b981 !important;
  }

  .wrong{
    background:#ef4444 !important;
  }

  .il-q-body{
    flex:1;
    min-width:0;
  }

  .il-q-text{
    line-height:1.9;
    font-size:16px;
    color:#111827;
  }

  .il-input{
    border:none;
    border-bottom:2px solid #10b981;
    outline:none;
    background:transparent;
    padding:4px 8px;
    width:min(170px,100%);
    font-size:15px;
    margin:0 4px;
  }

  .il-input:focus{
    border-color:#047857;
  }

  .il-input-warning{
    border-bottom-color:#dc2626;
    background:#fef2f2;
  }

  .il-blank-result{
    display:inline-block;
    min-width:60px;
    padding:3px 12px;
    margin:0 4px;
    border-radius:8px;
    font-weight:700;
    text-align:center;
    line-height:1.4;
    vertical-align:baseline;
  }

  .il-blank-correct{
    background:#ecfdf5;
    color:#047857;
    border-bottom:2px solid #10b981;
  }

  .il-blank-wrong{
    background:#fef2f2;
    color:#dc2626;
    border-bottom:2px solid #ef4444;
    text-decoration:line-through;
    text-decoration-color:#ef4444;
  }

  .il-word-warning{
    margin-top:8px;
    font-size:12px;
    font-weight:700;
    color:#dc2626;
  }

  .il-options{
    display:flex;
    flex-direction:column;
    gap:8px;
    margin-top:10px;
  }

  .il-option{
    display:flex;
    gap:12px;
    padding:11px 13px;
    border:1px solid #e5e7eb;
    border-radius:12px;
    cursor:pointer;
    transition:.25s;
    line-height:1.5;
    background:white;
  }

  .il-option:hover{
    background:#f0fdf4;
    border-color:#86efac;
  }

  .selected{
    background:#ecfdf5;
    border-color:#10b981;
  }

  .result-correct{
    background:#ecfdf5;
    border-color:#10b981;
  }

  .result-wrong{
    background:#fef2f2;
    border-color:#ef4444;
  }

  .il-radio{
    width:18px;
    height:18px;
    border:2px solid #9ca3af;
    border-radius:50%;
    margin-top:2px;
    position:relative;
    flex-shrink:0;
  }

  .checked::after,
  .correct-radio::after,
  .wrong-sel::after{
    content:'';
    width:8px;
    height:8px;
    border-radius:50%;
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
  }

  .checked{
    border-color:#10b981;
  }

  .checked::after{
    background:#10b981;
  }

  .correct-radio{
    border-color:#10b981;
  }

  .correct-radio::after{
    background:#10b981;
  }

  .wrong-sel{
    border-color:#ef4444;
  }

  .wrong-sel::after{
    background:#ef4444;
  }

  .il-answer-reveal{
    margin-top:12px;
    background:#f0fdf4;
    border-left:4px solid #10b981;
    padding:12px 14px;
    border-radius:8px;
    color:#065f46;
  }

  .il-result-icon{
    flex-shrink:0;
    padding-top:4px;
  }

  .il-map-layout{
    display:flex;
    gap:20px;
    flex-wrap:wrap;
  }

  .il-map-img{
    width:100%;
    border-radius:14px;
    border:1px solid #e5e7eb;
  }

  .il-map-table-wrap{
    flex:1 1 450px;
    overflow-x:auto;
  }

  .il-map-table{
    width:100%;
    border-collapse:collapse;
    min-width:600px;
  }

  .il-map-th{
    padding:12px;
    background:#ecfdf5;
    color:#065f46;
  }

  .il-map-th-label{
    background:#ecfdf5;
    min-width:180px;
  }

  .il-map-th,
  .il-map-td-radio,
  .il-map-th-label,
  .il-map-th-icon,
  .il-map-td-label,
  .il-map-td-icon{
    border:1px solid #d1d5db;
  }

  .il-map-td-label{
    padding:12px;
  }

  .il-map-td-label-inner{
    display:flex;
    gap:10px;
    align-items:center;
  }

  .il-map-text{
    font-weight:600;
  }

  .il-map-td-radio{
    text-align:center;
    cursor:pointer;
    padding:10px;
  }

  .il-radio-cell{
    width:18px;
    height:18px;
    border-radius:50%;
    border:2px solid #bbb;
    margin:auto;
  }

  .radio-checked{
    background:#047857;
    border-color:#047857;
    box-shadow: inset 0 0 0 3px white;
  }

  .radio-correct{
    background:#10b981;
    border-color:#10b981;
    box-shadow: inset 0 0 0 3px white;
  }

  .radio-wrong{
    background:#ef4444;
    border-color:#ef4444;
    box-shadow: inset 0 0 0 3px white;
  }

  .il-submit-area{
    display:flex;
    justify-content:flex-end;
    margin-top:24px;
  }

  .il-submit-btn{
    width:100%;
    max-width:280px;
    background:#10b981;
    color:white;
    border:none;
    padding:15px 24px;
    border-radius:16px;
    font-size:16px;
    font-weight:700;
    cursor:pointer;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:10px;
    box-shadow:0 8px 24px rgba(16,185,129,.25);
    transition:.25s;
  }

  .il-submit-btn:hover{
    background:#059669;
    transform:translateY(-2px);
  }

  .il-result-banner{
    background:white;
    color:#111827;
    padding:28px 20px;
    border-radius:20px;
    text-align:center;
    margin-bottom:20px;
    border:2px solid #bbf7d0;
    box-shadow:0 8px 24px rgba(0,0,0,.05);
  }

  .il-result-score{
    font-size:clamp(48px,8vw,72px);
    color:#059669;
    font-weight:800;
  }

  .il-result-band{
    display:inline-flex;
    align-items:baseline;
    gap:8px;
    margin-top:10px;
    background:#ecfdf5;
    border:1px solid #bbf7d0;
    padding:10px 22px;
    border-radius:999px;
  }

  .il-result-band-label{
    font-size:13px;
    font-weight:700;
    color:#047857;
    text-transform:uppercase;
    letter-spacing:.5px;
  }

  .il-result-band-value{
    font-size:26px;
    font-weight:800;
    color:#047857;
  }

  .il-result-btn{
    margin-top:20px;
    background:#10b981;
    color:white;
    border:none;
    padding:12px 24px;
    border-radius:14px;
    cursor:pointer;
    font-weight:700;
  }

  .il-overlay{
    position:fixed;
    inset:0;
    background:rgba(0,0,0,.45);
    backdrop-filter:blur(4px);
    z-index:9999;
    display:flex;
    align-items:center;
    justify-content:center;
    padding:20px;
  }

  .il-start-card{
    width:100%;
    max-width:460px;
    background:white;
    border-radius:24px;
    padding:28px 26px;
    text-align:center;
    box-shadow:0 20px 50px rgba(0,0,0,.15);
  }

  .il-start-icon{
    font-size:44px;
    color:#10b981;
    margin-bottom:10px;
  }

  .il-rules{
    text-align:left;
    margin:18px 0;
    background:#f9fafb;
    padding:16px 18px;
    border-radius:14px;
    border:1px solid #e5e7eb;
  }

  .il-rule{
    margin-bottom:10px;
    line-height:1.5;
    font-size:14px;
  }

  .il-error{
    background:#fef2f2;
    color:#dc2626;
    padding:12px;
    border-radius:10px;
    margin-bottom:20px;
    display:flex;
    gap:10px;
    border:1px solid #fecaca;
  }

  .il-start-btn{
    width:100%;
    border:none;
    background:#22c55e;
    color:white;
    padding:16px;
    border-radius:16px;
    font-size:16px;
    font-weight:700;
    cursor:pointer;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:10px;
    transition:.25s;
  }

  .il-start-btn:hover{
    background:#16a34a;
    transform:translateY(-2px);
  }

  @media(max-width:992px){

    .il-container{
      padding:16px;
    }

    .il-map-layout{
      flex-direction:column;
    }
  }

  @media(max-width:768px){

    .il-container{
      padding:12px;
    }

    .il-timer-bar{
      padding:12px;
      align-items:flex-start;
    }

    .il-timer-clock{
      font-size:15px;
    }

    .il-section-header{
      padding:16px;
    }

    .il-group{
      padding:16px;
    }

    .il-q-text{
      font-size:15px;
    }

    .il-option{
      padding:12px;
    }

    .il-map-table{
      min-width:520px;
    }

    .il-submit-btn{
      max-width:100%;
    }

    .il-start-card{
      padding:24px 18px;
    }
  }

  @media(max-width:480px){

    .il-timer-bar h1{
      font-size:18px;
    }

    .il-q-num{
      width:30px;
      height:30px;
      font-size:12px;
    }

    .il-q-text{
      font-size:14px;
    }

    .il-option-text{
      font-size:14px;
    }

    .il-result-score{
      font-size:44px;
    }
  }
`}</style>

        {!showResult && (
          <div className="il-timer-bar">
            <div className="il-timer-left">
              <h1 style={{ margin: 0 }}>IELTS Listening Practice Test</h1>
              <span className="il-timer-subtitle">
                40 questions · 4 parts
              </span>
            </div>

            <div className="il-timer-right">
              <div className="il-progress-pill">
                {getAnsweredCount()}/{getTotalQuestions()} answered
              </div>

              <div
                className={`il-timer-clock ${
                  timeLeft < 300 ? "warning" : ""
                }`}
              >
                <FiClock />
                {formatTime(timeLeft)}
              </div>
            </div>

            <div aria-live="polite" className="il-sr-only">
              {announcement}
            </div>
          </div>
        )}

        <div
          className={`il-container ${
            showResult ? "il-container-no-timer" : ""
          }`}
        >
          {!hasStarted && !showResult && (
            <div className="il-overlay">
              <div className="il-start-card">
                <div className="il-start-icon">
                  <FiVolume2 />
                </div>

                <h2>Listening Test Ready</h2>

                <p>
                  Make sure your speakers or headphones are
                  working.
                </p>

                {audioError && (
                  <div className="il-error">
                    <FiAlertTriangle />
                    <span>{audioError}</span>
                  </div>
                )}

                <div className="il-rules">
                  <div className="il-rule">
                    • Audio plays once only — you cannot pause,
                    rewind, or skip ahead, just like the real test
                  </div>

                  <div className="il-rule">
                    • No replay allowed
                  </div>

                  <div className="il-rule">
                    • Test auto-submits after 30 minutes
                  </div>
                </div>

                <button
                  className="il-start-btn"
                  onClick={startTest}
                >
                  <FiPlay />
                  Start Test
                </button>
              </div>
            </div>
          )}

          {showSubmitConfirm && (
            <div className="il-overlay">
              <div className="il-start-card">
                <div className="il-start-icon">
                  <FiAlertTriangle />
                </div>

                <h2>Unanswered Questions</h2>

                <p>
                  You still have{" "}
                  {getTotalQuestions() - getAnsweredCount()} question
                  {getTotalQuestions() - getAnsweredCount() === 1
                    ? ""
                    : "s"}{" "}
                  unanswered. In the real IELTS test you cannot go
                  back once time is up — submit anyway?
                </p>

                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    marginTop: "20px",
                  }}
                >
                  <button
                    className="il-result-btn"
                    style={{ flex: 1, background: "#6b7280", marginTop: 0 }}
                    onClick={() => setShowSubmitConfirm(false)}
                  >
                    Go Back
                  </button>

                  <button
                    className="il-result-btn"
                    style={{ flex: 1, marginTop: 0 }}
                    onClick={() => {
                      setShowSubmitConfirm(false);
                      handleCalculateScore();
                    }}
                  >
                    Submit Anyway
                  </button>
                </div>
              </div>
            </div>
          )}

          {hasStarted && !showResult && (
            <div className="il-live-badge">
              <span className="il-live-dot"></span>
              AUDIO PLAYING
            </div>
          )}

          {showResult && (
            <div className="il-result-banner">
              <h2>Test Complete</h2>

              <div className="il-result-score">
                {score}/40
              </div>

              <div>
                {Math.round((score / 40) * 100)}%
                correct
              </div>

              <div className="il-result-band">
                <span className="il-result-band-label">
                  Band Score
                </span>
                <span className="il-result-band-value">
                  {formatBand(getBandScore(score))}
                </span>
              </div>

              {saveStatus === "saved" && (
                <div className="il-save-note saved">
                  Result saved to your account.
                </div>
              )}

              {saveStatus === "failed" && (
                <div className="il-save-note failed">
                  Your score above is accurate, but it couldn't be
                  saved to your account. Please check your connection.
                </div>
              )}

              {saveStatus === "skipped" && (
                <div className="il-save-note skipped">
                  Sign in next time to keep a history of your scores.
                </div>
              )}

              <button
                className="il-result-btn"
                onClick={() => navigate("/")}
              >
                Back to Menu
              </button>
            </div>
          )}

          {IELTS_DATA_LISTENING.sections.map(
            (section, sIdx) => (
              <div
                className="il-section"
                key={section.id}
              >
                <div className="il-section-header">
                  <div className="il-section-label">
                    Part {sIdx + 1}
                  </div>

                  <div className="il-section-title">
                    {section.title}
                  </div>
                </div>

                {sIdx === 0 && (
                  <div
                    className={`il-audio-wrap ${
                      showResult ? "il-audio-disabled" : ""
                    }`}
                  >
                    <span>Test Audio</span>

                    <audio
                      ref={(el) =>
                        (audioRefs.current[section.id] = el)
                      }
                      src={section.audioSrc}
                      controls
                      controlsList="nodownload noplaybackrate"
                      onTimeUpdate={(e) => {
                        audioLastTimeRef.current[section.id] =
                          e.target.currentTime;
                      }}
                      onSeeking={(e) => {
                        const el = e.target;
                        const last =
                          audioLastTimeRef.current[section.id] || 0;

                        if (Math.abs(el.currentTime - last) > 0.05) {
                          el.currentTime = last;
                        }
                      }}
                      onKeyDown={(e) => {
                        const blockedKeys = [
                          "ArrowLeft",
                          "ArrowRight",
                          "Home",
                          "End",
                        ];
                        if (blockedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onPause={(e) => {
                        const el = e.target;

                        if (audioForceStopRef.current) {
                          return;
                        }

                        if (!el.ended && testActiveRef.current) {
                          setTimeout(() => {
                            el.play().catch(() => {});
                          }, 0);
                        }
                      }}
                    />

                    <span className="il-audio-note">
                      No pause, rewind, or skip-ahead — just like the
                      real exam
                    </span>
                  </div>
                )}

                {section.questionGroups.map(
                  (grp, gIdx) => {
                    const maxWords = getMaxWords(grp.instruction);

                    return (
                      <div
                        className="il-group"
                        key={gIdx}
                      >
                        <div className="il-instruction">
                          {grp.instruction}
                        </div>

                        {grp.mapOptions ? (
                          renderMapGroup(grp)
                        ) : (
                          <div className="il-questions-grid">
                            {grp.questions.map((item) =>
                              renderQuestion(item, maxWords)
                            )}
                          </div>
                        )}
                      </div>
                    );
                  }
                )}
              </div>
            )
          )}

          {!showResult && (
            <div className="il-submit-area">
              <button
                className="il-submit-btn"
                onClick={handleSubmitClick}
              >
                Submit Test
                <FiSave />
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}